<div #editorMenu class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editorNgx" [toolbar]="toolbar"></ngx-editor-menu>
    <ngx-editor
        [(ngModel)]="editorContentGetter"
        (ngModelChange)="onChange($event)"
        [disabled]="false"
        [editor]="editorNgx"
        [placeholder]="''"
        (paste)="onPaste($event)"
    ></ngx-editor>
</div>

<button
    type="button"
    (click)="emojiCheckbox.checked = !emojiCheckbox.checked"
    class="flex items-center justify-center bg-white w-[30px] h-[30px] rounded-sm hover:bg-zinc-200"
    #emojiButton
>
    <i class="fas fa-smile"></i>
    <div *ngIf="emojiCheckbox.checked" class="absolute mt-96 -ml-80 p-4 bg-white border rounded shadow-lg w-80 flex flex-wrap z-99999">
        <span class="icon-size-5 mr-1 mb-1" *ngFor="let e of emojiArray" (click)="insertNgxEmoji(e[1])">{{ e[1] }}</span>
    </div>
    <input type="checkbox" class="invisible absolute" #emojiCheckbox />
</button>
<button
    type="button"
    (click)="linkCheckbox.checked = !linkCheckbox.checked"
    class="flex items-center justify-center bg-white w-[30px] h-[30px] rounded-sm hover:bg-zinc-200 linkButton"
    #linkButton
>
    <i class="fas fa-link"></i>
    <div *ngIf="linkCheckbox.checked" class="absolute p-5 mt-60 bg-white border border-gray-200 rounded-lg shadow-xl w-80 z-99999 link-dialog">
        <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-1 text-left">URL (S podporou Sting:// protokolu):</label>
            <input
                type="text"
                [(ngModel)]="linkUrl"
                placeholder="Sting://odkaz"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500 transition-colors"
                (keyup.enter)="insertCustomLink()"
                (click)="$event.stopPropagation()"
                #urlInput
            />
        </div>
        <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-1 text-left">Text odkazu (volitelné):</label>
            <input
                type="text"
                [(ngModel)]="linkText"
                placeholder="Zobrazovaný text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500 transition-colors"
                (keyup.enter)="insertCustomLink()"
                (click)="$event.stopPropagation()"
            />
        </div>
        <div class="flex justify-end gap-2">
            <button
                type="button"
                class="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors"
                (click)="closeLinkDialog(); $event.stopPropagation()"
            >
                Zrušit
            </button>
            <button
                type="button"
                class="px-3 py-1 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors font-medium"
                (click)="insertCustomLink(); $event.stopPropagation()"
            >
                Vložit odkaz
            </button>
        </div>
    </div>
    <input type="checkbox" class="invisible absolute" #linkCheckbox />
</button>
